import { pipe } from 'ramda'
import { connect } from 'react-redux'
import Confirmation from './confirmation'
import mapStateToProps from './confirmation.selector'

export default pipe(
  connect(mapStateToProps, null)
)(Confirmation)
